// WFH Status
export const WFH_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

export const WFH_STATUS_LABELS = {
  [WFH_STATUS.PENDING]: 'Pending',
  [WFH_STATUS.APPROVED]: 'Approved',
  [WFH_STATUS.REJECTED]: 'Rejected',
  [WFH_STATUS.CANCELLED]: 'Cancelled',
};

// Status Colors for badges
export const WFH_STATUS_COLORS = {
  [WFH_STATUS.PENDING]: 'warning',
  [WFH_STATUS.APPROVED]: 'success',
  [WFH_STATUS.REJECTED]: 'error',
  [WFH_STATUS.CANCELLED]: 'default',
};

// Half Day Types
export const WFH_HALF_DAY_TYPES = {
  FIRST_HALF: 'first_half',
  SECOND_HALF: 'second_half',
};

export const WFH_HALF_DAY_TYPE_LABELS = {
  [WFH_HALF_DAY_TYPES.FIRST_HALF]: 'Morning (First Half)',
  [WFH_HALF_DAY_TYPES.SECOND_HALF]: 'Afternoon (Second Half)',
};

// Initial form state
export const INITIAL_WFH_FORM_STATE = {
  startDate: null,
  endDate: null,
  isHalfDay: false,
  halfDayType: '',
  reason: '',
  reviewers: [],
};

// Table columns
export const WFH_TABLE_COLUMNS = [
  { id: 'employee', label: 'Employee', alignRight: false },
  { id: 'startDate', label: 'Start Date', alignRight: false },
  { id: 'endDate', label: 'End Date', alignRight: false },
  { id: 'totalDays', label: 'Days', alignRight: false },
  { id: 'halfDay', label: 'Half Day', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'actions', label: '', alignRight: true },
];
